import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link as GatsbyLink, navigate } from 'gatsby';
import { Link } from '@printdeal/ui-library';

import useSystemPages from '../../hooks/useSystemPages';
import {
  dispatchDataLayerEventOnLostPasswordClick,
} from '../../helpers/dataLayerHelpers/LoginDataLayerHelper';

interface LostPasswordLinkProps {
  linkLocation?: string;
  eventLabel?: string;
  handleResetPasswordLinkClick?: () => void | undefined;
}

const LostPasswordLink = ({
  linkLocation = '',
  eventLabel,
  handleResetPasswordLinkClick = () => {},
}: LostPasswordLinkProps) => {
  const [lostPasswordPage] = useSystemPages('lostPassword');

  const handleLostPasswordLinkClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    dispatchDataLayerEventOnLostPasswordClick(linkLocation, eventLabel);
    if (linkLocation === 'slideout') {
      handleResetPasswordLinkClick();
    } else {
      navigate(lostPasswordPage.path, { replace: false });
    }
  };

  if (!lostPasswordPage?.path) {
    return (null);
  }

  return (
    <Link as={GatsbyLink} to={lostPasswordPage.path} onClick={handleLostPasswordLinkClick}>
      <FormattedMessage
        defaultMessage="Forgot password?"
        id="account.login.form.label.passwordreset"
      />
    </Link>
  );
};

export default LostPasswordLink;
